import { Avatar, Col, Form, Input, message, Modal, notification, Row } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { generateMessageError } from '../../../../../utils'
import configuration from '../../../../../../configuration'
import { Button } from 'modules/core/components'

const BookmarkModal = ({
  bookmark,
  showBookmark,
  setShowBookmark,
  createBookmark,
  editBookmark,
  deleteBookmark,
}) => {
  const { t } = useTranslation()

  const [form] = Form.useForm()

  useEffect(() => {
    if (showBookmark) {
      form.setFieldsValue({
        id: bookmark?.id,
        name: bookmark?.name ?? document.title,
        url: bookmark?.url ?? window.location.href,
      })
    }
  }, [showBookmark, bookmark, form])

  const onCancel = () => {
    form.resetFields()
    setShowBookmark(false)
  }

  const onConfirm = () => {
    form.validateFields().then((values) => {
      if (bookmark) {
        editBookmark(bookmark.id, values)
          .then(() => {
            onCancel()
            message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
          })
          .catch((error) => {
            onCancel()
            notification.error({
              message: t('FEEDBACK_DEFAULT_ERROR'),
              description: generateMessageError(error),
              duration: 0,
            })
          })
      } else {
        createBookmark(values)
          .then(() => {
            onCancel()
            message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
          })
          .catch((error) => {
            onCancel()
            notification.error({
              message: t('FEEDBACK_DEFAULT_ERROR'),
              description: generateMessageError(error),
              duration: 0,
            })
          })
      }
    })
  }

  const onDelete = () => {
    if (bookmark) {
      deleteBookmark(bookmark.id)
        .then(() => {
          onCancel()
          message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
        })
        .catch((error) => {
          onCancel()
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error),
            duration: 0,
          })
        })
    }
  }

  return (
    <Modal
      visible={showBookmark}
      onCancel={onCancel}
      onOk={onConfirm}
      title={t('EDIT_BOOKMARK_LABEL')}
      cancelText={t('ACTION_DELETE')}
      okText={t('ACTION_SAVE')}
      footer={
        <>
          <Button.Default onClick={onCancel} title="ACTION_CANCEL" />
          {bookmark && <Button.Default onClick={onDelete} title="ACTION_DELETE" />}
          <Button.Primary onClick={onConfirm} title="ACTION_SAVE" />
        </>
      }
    >
      <Row>
        <Col span={6}>
          <Avatar shape="square" size={90}>
            P
          </Avatar>
        </Col>
        <Col span={18}>
          <Form form={form} layout="vertical">
            <Form.Item
              label="Nombre"
              name="name"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Enlace"
              name="url"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Input disabled={true} />
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  bookmarks: configuration.selectors.getBookmarks(state),
})

const mapDispatchToProps = {
  createBookmark: configuration.actions.createBookmark,
  editBookmark: configuration.actions.editBookmark,
  deleteBookmark: configuration.actions.deleteBookmark,
}

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkModal)
